import { render, staticRenderFns } from "./BranchHisto.vue?vue&type=template&id=2205f6c8&"
import script from "./BranchHisto.vue?vue&type=script&lang=js&"
export * from "./BranchHisto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports